var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
var Ng1PricingDirective = /** @class */ (function (_super) {
    __extends(Ng1PricingDirective, _super);
    function Ng1PricingDirective(elementRef, injector) {
        return _super.call(this, 'pricing', elementRef, injector) || this;
    }
    return Ng1PricingDirective;
}(UpgradeComponent));
export { Ng1PricingDirective };
